import type { ExtendedBlock } from 'widget-components/integrations/CustomPage/types'

export const flattenBlocks = (blocks: (ExtendedBlock | undefined)[]): ExtendedBlock[] => blocks.flatMap(child => {
    if (!child) {
        return []
    }
    if ('children' in child) {
        return [child, ...flattenBlocks(child.children as ExtendedBlock[])]
    }
    if (Array.isArray(child)) {
        return [...flattenBlocks(child)]
    }
    return [child]
})
